module.exports = __webpack_public_path__ + "media/34.12bc3726.ogg";